module.exports = __webpack_public_path__ + "img/AdamNeuhaus-PatrickKluivert_old.1e4b96bf.webp";